import type { RouteObject } from "react-router";

import { ErrorPage } from "@/components/Error/ErrorPage";
import { canAccessPracticalAndMore } from "@/components/ProjectSidebar/permissions";
import { RequireAuth } from "@/components/Routing/RequireAuth";
import { DocumentsListPage } from "@/modules/documents/pages/documents-list/DocumentsListPage";
import { CreateDocumentFilePage } from "@/modules/documents/pages/file-editor/CreateDocumentFilePage";
import { EditDocumentFilePage } from "@/modules/documents/pages/file-editor/EditDocumentFilePage";
import { CreateDocumentFolderPage } from "@/modules/documents/pages/folder-editor/CreateDocumentFolderPage";
import { EditDocumentFolderPage } from "@/modules/documents/pages/folder-editor/EditDocumentFolderPage";
import { CreateDocumentRootPage } from "@/modules/documents/pages/root-editor/CreateDocumentRootPage";
import { EditDocumentRootPage } from "@/modules/documents/pages/root-editor/EditDocumentRootPage";
import { DocumentRootListPage } from "@/modules/documents/pages/root-list/DocumentsRootListPage";

import { canManageAllDocuments } from "./permissions";
import { documentsRoutes } from "./routes";

export const documentsRoute = [
  {
    path: documentsRoutes.rootList,
    element: (
      <RequireAuth permission={canAccessPracticalAndMore}>
        <DocumentRootListPage />
      </RequireAuth>
    ),
  },
  {
    path: documentsRoutes.rootCreate,
    element: (
      <RequireAuth permission={canManageAllDocuments}>
        <CreateDocumentRootPage />
      </RequireAuth>
    ),
  },
  {
    path: documentsRoutes.rootEdit,
    element: (
      <RequireAuth permission={canManageAllDocuments}>
        <EditDocumentRootPage />
      </RequireAuth>
    ),
  },
  { path: documentsRoutes.documentsList, element: <DocumentsListPage /> },
  { path: documentsRoutes.fileCreate, element: <CreateDocumentFilePage /> },
  { path: documentsRoutes.fileEdit, element: <EditDocumentFilePage /> },
  { path: documentsRoutes.folderCreate, element: <CreateDocumentFolderPage /> },
  { path: documentsRoutes.folderEdit, element: <EditDocumentFolderPage /> },
  { path: "*", element: <ErrorPage status={404} /> },
] satisfies RouteObject[];
